import { get, post } from "../request";
import { STAT_BASE_URL } from "@/config/statConfig";
import statRequest from "../statRequest";
/* 统计  日报 模块*/
export default {
  /**
   * @description 查询当前日期
   * @param {String} params
   * @returns Object
   */
  getSelectNewDay(params) {
    return get(`/newStatistics/statis?${params}`);
  },
  /**
   * @description 查询当前班次
   * @returns Object
   */
  getSelectShift() {
    return get(`/shift/selectAll`,{},true);
  },

  /**
   * @description 查询具体时间(按日,按班次)
   * @param {String} params
   * @returns Object
   */
  getSelectTime(params) {
    return get(`/newStatistics/selectTime?${params}`);
  },
  /**
   * @description 查询支付通道入账明细
   * @returns Object
   */
  getSelectAccesDetail(params) {
    return get(`/payServiceOrder/selectAll`, params);
  },
  /**
   * @description 查询油枪油量统计数据
   * @param {String} shiftId 班次ID
   * @returns Object
   */
  getAllOilByOilGunName(params) {
    return get(`/admin/order/allOilByOilGunName`, params, true);
  },
  /**
   * @description 查询油品类型统计数据
   * @param {String} shiftId 班次ID
   * @returns Object
   */
  getAllOilByOilType(params) {
    return get(`/admin/order/allOilByOilType`, params, true);
  },
  /**
   * @description 查询罐号类型统计数据
   * @param {String} shiftId 班次ID
   * @returns Object
   */
  getAllOilByCanNumber(params) {
    return get(`/admin/order/allOilByCanNumber`, params, true);
  },
  /**
   * @description 导出Excel数据
   * @param {String} shiftId 班次ID
   * @returns Object
   */
  exportAllOilExcel(shiftId) {
    return get(`/admin/order/allOilExcel?shiftId=${shiftId}`, {}, true);
  },

  /**
   * @description 查询罐号班次数据
   * @param {Object} params 查询参数
   * @returns Object
   */
  selectCanShift(params) {
    return post(`/canShift/selectCanShift`, params);
  },

  /**
   * @description 修改罐号班次数据
   * @param {Object} params 修改参数
   * @returns Object
   */
  updateCanShift(params) {
    return post(`/canShift/updateCanShift`, params);
  },

  canOilStatistics(params) {
    console.log('入库统计',params);
    return get(`/gauge/canOilStatistics`, params);
  },

  // 油品统计对比相关API
  /**
   * @description 获取油品销量同比数据（日）
   * @param {Object} params 查询参数
   * @returns Object
   */
  getDailyCompare(params) {
    return get(`/chart/dailyCompare`, params);
  },

  /**
   * @description 获取油品销量同比数据（周）
   * @param {Object} params 查询参数
   * @returns Object
   */
  getWeeklyCompare(params) {
    return get(`/chart/weeklyCompare`, params);
  },

  /**
   * @description 获取油品销量同比数据（月）
   * @param {Object} params 查询参数
   * @returns Object
   */
  getMonthlyCompare(params) {
    return get(`/chart/monthlyCompare`, params);
  },

  /**
   * @description 获取自定义时间范围对比数据
   * @param {Object} params 查询参数
   * @returns Object
   */
  getCompareData(params) {
    return post(`/chart/compareData`, params);
  },

  /**
   * @description 获取统计汇总数据
   * @param {Object} params 查询参数
   * @returns Object
   */
  getSummaryData(params) {
    return get(`/chart/summaryData`, params);
  },

  /**
   * @description 获取统计连接配置
   * @param {String} connId 连接ID
   * @returns Object
   */
  getStatConnections(connId) {
    return statRequest.get(`${STAT_BASE_URL}/api/stat/connections/${connId}`);
  },

  /**
   * @description 获取统计数据
   * @param {String} id 统计ID
   * @returns Object
   */
  getStatData(id) {
    return statRequest.get(`${STAT_BASE_URL}/api/stat/data/${id}`);
  },

  /**
   * @description 批量获取统计数据
   * @param {Object} data {ids: Array, timeRange: String, timeStart: String, timeEnd: String}
   * @returns Object
   */
  batchRunStat(data) {
    return statRequest.post(`${STAT_BASE_URL}/api/stat/batch-run`, data);
  },

  /**
   * @description 获取点选分组明细数据
   * @param {Object} params {cfgId: String, groupValue: String, page: Number, pageSize: Number}
   * @returns Object
   */
  getStatDetail(params) {
    const { cfgId, ...query } = params || {};
    return statRequest.get(`${STAT_BASE_URL}/api/stat/${cfgId}/detail`, { params: query });
  },
};